module.exports = __webpack_public_path__ + "media/images/emblems/Chene-Paquier-coat_of_arms-2844bd5b52e7f2090a3a4ae01fe9c3b2.svg";